import { render, staticRenderFns } from "./underwirting.vue?vue&type=template&id=01b61419&scoped=true&"
import script from "./underwirting.vue?vue&type=script&lang=js&"
export * from "./underwirting.vue?vue&type=script&lang=js&"
import style0 from "./underwirting.vue?vue&type=style&index=0&id=01b61419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b61419",
  null
  
)

export default component.exports